<template>
    <ContentOrLoading>
        <div class="row" v-if="! loading">
            <div class="col-12">
                <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                    <div class="form-group">
                        <label for="id">{{ $t('formularios.id') }}</label>
                        <ValidationProvider name="ID" rules="required" v-slot="{ errors }">
                            <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="ID" v-model="id_persona"/>
                        </ValidationProvider>
                    </div>
                    <div class="form-group">
                        <label for="pin">{{ $t('formularios.pin') }}</label>
                        <ValidationProvider name="pin" rules="required" v-slot="{ errors }">
                            <input type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="PIN" v-model="pin"/>
                        </ValidationProvider>
                    </div>
                    
                    <button type="submit" class="button large-button effect-button"><span>{{ $t('renovar_abono.renovar') }}</span></button>
                </ValidationObserver>
            </div>
            <div class="col-12" v-if="error">
                <section class="padding-vertical-content">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="alert alert-danger" role="alert">
                                    <p>{{ error }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import ContentOrLoading from '@/components/backend/components/ContentOrLoading';

    export default {        
        data() {
            return {
                dni: '',
                loading: false,
                error: false,
                id_persona: '',
                pin: ''
            }
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro;
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.buscarAbonado();
                }
            },
            terminar() {
                this.$emit('terminado', {
                    id_persona: this.id_persona,
                    pin: this.pin
                });
            },
            buscarAbonado() {
                this.loading = true;

                const params = {
                    tid: this.configuracion.hash_teatro,
                    dni: this.dni,
                    pin: this.pin,
                    id_persona: this.id_persona
                }

                this.$store.dispatch(this.config.getVuexAlias('lfp.buscar.abono'), params).then(res => {
                    this.loading = false;
                    this.$emit('terminado', res.data);
                }).catch(error => {
                    this.loading = false;
                    this.error = error.response.data.message;
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'akr1V2vNbDdxA3CkLniS') {
                        this.error = 'Nº de ID o PIN incorrecto. Por favor escriba a abonados@albacetebalompie.com con su Nombre, apellidos y DNI';
                    }
                    if(error.response.data.message == 'Nº de abonado o dni incorrecto.' && this.configuracion.hash_teatro == 'I0QtpDfZsTkgWKert1Gp') {
                        this.error = 'Nº ID o PIN incorrecto.';
                    }
                });
            },
        },
        components: {
            ContentOrLoading
        }
    }
</script>
